module.exports = __webpack_public_path__ + "static/media/baseline-menu-24px.8fbc7c70.svg";